import React from 'react';
import numeral from 'numeral';
import { connect } from 'react-redux';

import { updateOrder } from 'actions/orders';
import { titleSelector } from 'selectors/order-create';

import Card from 'components/common/Card';

import {
  Button,
  FlexItem,
  CertTitle,
  CertPrice,
  StepTitle,
  CertContain,
  StepSubTitle,
  ContentContain,
  UploadHelpText,
  CertDescription,
  StepInformation
} from '../CreateStyled';

import PendingFile from 'components/FileUploader/components/PendingFile';

import { stepTitleSearch as handleValidate } from '../validation/';
import useUploadDialog from '../useUploadDialog';
import { TITLE_SEARCH_FEE } from 'constants/app';

const OrderOption = ({
  text,
  title,
  price,
  color,
  selected,
  description,
  disableHover,
  onClick = () => null
}) => {
  return (
    <CertContain
      onClick={onClick}
      selected={selected} 
      disableHover={disableHover}
    >
      <FlexItem flex={1}>
        <CertTitle color={color}>{title}</CertTitle>
        <CertDescription>
          {description}
        </CertDescription>
      </FlexItem>
      {price && <CertPrice>{price}</CertPrice>}
    </CertContain>
  );
};

export const StepTitleSearch = ({
  orderTitle,
  updateOrder,
  renderActions,
  pendingUpload,
  hideOrderTitle,
  disableOrderTitle
}) => {
  const handleUpload = (file) => {
    updateOrder({ title: file, upload_title: true });
  };

  const [renderUploadDialog, openDialog] = useUploadDialog(handleUpload);

  const handleOpenDialog = () => {
    updateOrder({ order_title: false, title: null });
    openDialog(true);
  };

  const handleNext = () => handleValidate();

  const handleRemoveFile = () => updateOrder({ title: null, upload_title: false });

  const handleOrderTitleClick = () => !disableOrderTitle &&
    updateOrder({ upload_title: false, order_title: true, title: null });

  const renderOrderTitle = () => !disableOrderTitle
    ? <OrderOption 
        selected={orderTitle}
        title="Request Title Search"
        onClick={handleOrderTitleClick}
        price={numeral(TITLE_SEARCH_FEE).format('$0,0.00')}
        description="Searchlight will provide the title search as part of the order."
      />
    : <OrderOption
        disableHover
        color="rgb(245,75,60)"
        title="Request Title Search - Unavailable"
        description="You can not order a title search when manually confirming the property address."
      />;

  return (
    <Card.Content>
      <ContentContain>
        <StepTitle>Title Search</StepTitle>
        <StepInformation>You must provide a Title Search document. {!hideOrderTitle ? 'Choose an option below.' : ''}</StepInformation>
        <StepSubTitle>Upload Title Document</StepSubTitle>

        <CertContain disableHover>
          <FlexItem flex={1}>
            <CertTitle>Upload Title Document</CertTitle>
            <CertDescription>Upload the title search document</CertDescription>
          </FlexItem>
          <Button onClick={handleOpenDialog}>Upload Title</Button>
        </CertContain>

        <UploadHelpText><span style={{ fontWeight: 500 }}>Multiple Titles</span> - Multiple titles can be uploaded as a <span style={{ fontWeight: 500 }}>.zip</span> file - alternatively additional documents can be uploaded after the order has been created.</UploadHelpText>

        {!!pendingUpload && <StepSubTitle>File Upload</StepSubTitle>}

        {!!pendingUpload && (
          <PendingFile
            file={pendingUpload}
            onFileDelete={handleRemoveFile}
            description="Title Search Document"
          />
        )}

        
        {!hideOrderTitle && (
          <React.Fragment>
            {!pendingUpload && <StepSubTitle>Add to Order</StepSubTitle>}
            {!pendingUpload && renderOrderTitle()}
          </React.Fragment>
        )}
        

        {renderUploadDialog()}

        {renderActions({
          disableNext: !pendingUpload && !orderTitle,
          onNext: handleNext
        })}
      </ContentContain>
    </Card.Content>
  );
};

StepTitleSearch.defaultProps = {
  inputErrors: {},
  onValueChange: () => null
};

export default connect(
  (state) => ({
    pendingUpload: titleSelector(state),
    orderTitle: state.pendingOrder.pending.order_title,
    uploadTitle: state.pendingOrder.pending.upload_title,
    hideOrderTitle: state.pendingOrder.pending.address_state === 'WA',
    disableOrderTitle: (
      !state.pendingOrder.pending.globalx_meta ||
      state.pendingOrder.pending.address_state === 'WA'
  )}),
  {
    dispatchOrderUpdate: updateOrder
  })(props =>
  <StepTitleSearch {...props}
    updateOrder={props.dispatchOrderUpdate}
  />
);

